import { render } from "./GlossaryHeader.vue?vue&type=template&id=229e8051&scoped=true&ts=true"
import script from "./GlossaryHeader.vue?vue&type=script&lang=ts"
export * from "./GlossaryHeader.vue?vue&type=script&lang=ts"

import "./GlossaryHeader.vue?vue&type=style&index=0&id=229e8051&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229e8051"]])

export default __exports__